import { gql } from '@apollo/client'

export const ROLE = gql`
  fragment Role on Role {
    id
    value
    permissions
    currentLabel
    roleType
  }
`
